import React from 'react';

const bannerBase =
  'w-full max-w-[420px] flex flex-col items-center justify-center gap-1 rounded-xl p-3.5 px-5 mx-auto max-md:p-4 max-md:px-5 max-md:gap-2';

const bannerVariants = {
  default:
    'bg-gradient-to-br from-[#1d4746] via-[#236463] to-[#12766d] shadow-[0_4px_16px_rgba(29,71,70,0.15)] dark:from-[#0f2928] dark:via-[#153938] dark:to-[#0d4f49]',
  drill:
    'bg-gradient-to-br from-[#1e3d6f] via-[#345d8a] to-[#4a6fa5] shadow-[0_4px_16px_rgba(30,61,111,0.15)] dark:from-[#162d50] dark:via-[#1e3d6f] dark:to-[#2e4a6e]',
};

export function ResultBanner({
  language,
  courseType,
  subcourseName = null,
  lessonName = null,
  practiceTypeLabel = null,
  subPracticeTypeLabel = null,
  subpracticeTypeLabel = null,
}) {
  const variant = courseType === 'Drill Vocab' ? 'drill' : 'default';
  const typeLabel = practiceTypeLabel || courseType;
  const contextLabels = [subPracticeTypeLabel, subpracticeTypeLabel].filter(Boolean);

  return (
    <div className={`${bannerBase} ${bannerVariants[variant]}`}>
      <div className="text-[10px] font-semibold text-white/85 uppercase tracking-[1px] max-md:tracking-[0.8px]">
        PRACTICING IN
      </div>
      <div className="text-lg font-bold text-white text-center my-0.5">{language}</div>
      <div className="flex flex-col items-center gap-0.5 w-full">
        {subcourseName && (
          <div className="text-sm font-semibold text-white/95 text-center">
            {subcourseName}
          </div>
        )}
        {lessonName && (
          <div className="text-xs font-medium text-white/90 text-center">
            {lessonName}
          </div>
        )}
        <div className="text-xs font-normal text-white/75 text-center">
          {typeLabel}
        </div>
        {contextLabels.length > 0 && (
          <div className="text-[11px] font-medium text-white/70 text-center">
            {contextLabels.join(' · ')}
          </div>
        )}
      </div>
    </div>
  );
}
